(function() { module.exports = this["forms"]; }());


//////////////////
// WEBPACK FOOTER
// external "forms"
// module id = 5
// module chunks = 0